
        require('./index.scss');
        'use strict';

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $ = window.$;
var $mod = $('.module-search-input');
var homeHostName = _config2['default'].homeHostName,
    homeDomain = _config2['default'].homeDomain;

var cityId = $mod.attr('data-cityid'),
    citySuffix = $mod.attr('data-citysuffix');
var _module = {
    init: function init() {
        this.search();
    },
    search: function search() {
        $mod.find('.search-input').keyup(function (e) {
            if (e.which == 13 && $(this).val() != "" && $(this).val() != $(this).data('placeholder')) {
                var keyWord = $(this).val();
                window.open('//' + citySuffix + '.' + homeHostName + '/zixun/search?cityId=' + cityId + '&keyword=' + encodeURIComponent(keyWord));
            }
        });
        $mod.find('.icon2018').click(function (e) {
            if ($(this).prev().val() != "" && $(this).prev().val() != $(this).prev().data('placeholder')) {
                var keyWord = $(this).prev().val();
                window.open('//' + citySuffix + '.' + homeHostName + '/zixun/search?cityId=' + cityId + '&keyword=' + encodeURIComponent(keyWord));
            }
        });
    }
};
_module.init();;
    


// WEBPACK FOOTER //
// ./src/module/common/search-input/index.js